<div class="sdp-section-container sdp-registration-section-container">
	<mat-card>
		<mat-card-title>
			{{ "form.label.signIn" | translate }}
		</mat-card-title>
		<div>
			<router-outlet></router-outlet>
		</div>
	</mat-card>
	<mat-progress-bar
		mode="indeterminate"
		*ngIf="progressVisible"
		class="sdp-registration-progress-bar"
	></mat-progress-bar>
	<mat-card
		*ngIf="isIdle"
		class="sdp-registration-message-block"
	>
		{{ "sdp.session.idle.logged.out" | translate }}
	</mat-card>
</div>